import { render, staticRenderFns } from "./music_list.vue?vue&type=template&id=63e84e4a&scoped=true&"
import script from "./music_list.vue?vue&type=script&lang=js&"
export * from "./music_list.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63e84e4a",
  null
  
)

export default component.exports